import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRoute,
  RouterStateSnapshot,
  ActivatedRouteSnapshot,
} from '@angular/router';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ApiService } from 'src/app/services/api/api.service';
import { DataService } from 'src/app/services/data/data.service';
import { UtilityService } from 'src/app/services/utility/utility.service';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private api: ApiService,
    private dataService: DataService,
    private route: ActivatedRoute,
    private utility: UtilityService,
    private translate: TranslateService
  ) {}

  USER_PERMISSIONS: any[] = [];
  url: any;

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    let url = state.url;

    if (url) {
      let urlSegments = url.split('/');
      const queryParams = route.params;
      //console.log(queryParams);
      if (queryParams) {
        Object.values(queryParams).forEach((element) => {
          urlSegments = urlSegments.filter((ele: any) => ele !== element);
        });
        this.url = urlSegments.join('/');
        // console.log(this.url);
      }
    }
    if (localStorage.getItem('token')) {
      let res = await this.getUserData();
      if (res) {
        return true;
      } else {
        return false;
      }
    } else {
      // not logged in so redirect to login page with the return url
      this.router.navigate(['/auth/login']);
      return false;
    }
  }

  async getUserData() {
    return new Promise((resolve, reject) => {
      this.api.getUserDetails().subscribe(
        (data: any) => {
          if (data && data.statusCode == '200' && data.message) {
            this.dataService.userDetails = data.message;
          }
        },
        (err) => {
          console.log(err);
          if (err?.error?.error?.toLowerCase() == 'invalid login') {
            this.router.navigate(['auth', 'login']);
            this.utility.alertError('Login Expired.', 'Please login again');
          }
          this.api.checkInvalidToken(err);
          reject(false);
        },
        () => {
          this.setLanguage();

          this.api
            .getUserPermissions(this.dataService.userDetails.id)
            .subscribe(
              (res: any) => {
                this.USER_PERMISSIONS = res.message;
                // console.log(this.USER_PERMISSIONS);
              },
              (err) => {
                console.log(err);
                this.utility.alertError(
                  err.error.error || 'Some error occurred.'
                );
              },
              () => {
                this.dataService.userPermissions = this.USER_PERMISSIONS;
                resolve(true);
              }
            );
        }
      );
    });
  }

  setLanguage() {
    if (localStorage.getItem('language')) {
      this.switchLanguage(localStorage.getItem('language') || 'en');
    } else {
      if (this.dataService.userDetails.language) {
        localStorage.setItem('language', this.dataService.userDetails.language);
        this.switchLanguage(this.dataService.userDetails.language);
      } else {
        this.switchLanguage('en');
      }
    }
  }

  switchLanguage(lang: string) {
    this.translate.use(lang);
  }
}
